// 定义初始状态
const initialState = {
  isAuthenticated: false,
  user: null,
  loading: false,
  error: null,
  authChecked: false // 是否已检查认证状态
};

// 定义动作类型
const AUTH_START = 'AUTH_START';
const AUTH_SUCCESS = 'AUTH_SUCCESS';
const AUTH_FAIL = 'AUTH_FAIL';
const AUTH_LOGOUT = 'AUTH_LOGOUT';
const AUTH_CHECK = 'AUTH_CHECK';
const UPDATE_USER_POINTS = 'UPDATE_USER_POINTS';

// 认证reducer
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_START:
      return {
        ...state,
        loading: true,
        error: null
      };
    case AUTH_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
        loading: false,
        error: null,
        authChecked: true
      };
    case AUTH_FAIL:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        loading: false,
        error: action.payload,
        authChecked: true
      };
    case AUTH_LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        loading: false,
        error: null,
        authChecked: true
      };
    case AUTH_CHECK:
      return {
        ...state,
        authChecked: true
      };
    case UPDATE_USER_POINTS:
      return {
        ...state,
        user: state.user ? {
          ...state.user,
          points: action.payload
        } : state.user
      };
    default:
      return state;
  }
};

export default authReducer; 